import { LastViewedObject } from "../../types/types";
import Page from "../Page";
import Tabs from "../Tabs";
import useFetchPage from "../hooks/useFetchPage";

interface Props {
  setLastViewed: (value: LastViewedObject) => void;
}

const Basics = ({ setLastViewed }: Props) => {
  const page = useFetchPage(setLastViewed);

  return (
    page && (
      <Page title={page.frontmatter.title} description={page.content}>
        {page.frontmatter.sections && (
          <Tabs sections={page.frontmatter.sections} />
        )}
      </Page>
    )
  );
};

export default Basics;
